<div class="report row">
  <div class="field col-12 col-md-6 col-xl-3">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Cluster ID:</span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.clusterId }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-5">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Cluster Name:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.clusterName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Cluster Location:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.clusterLocation }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6">
    <div class="row">
      <div class="col-5 col-md-4 d-flex justify-content-start">
        <span class="">Created By:</span>
      </div>
      <div class="col-7 col-md-8 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.createdBy }}
        </span>
      </div>
    </div>
  </div>
</div>